/** Alineado con backend `retryOutboundDelivery`. */
export const SENT_RETRY_MIN_AGE_MS = 45_000;
export const PENDING_RETRY_MIN_AGE_MS = 15_000;
/** Evita reenviar en loop mensajes viejos al reabrir el chat. */
export const AUTO_RETRY_MAX_AGE_MS = 24 * 60 * 60_000;
/** Tope de reenvíos automáticos por mensaje mientras el hilo está abierto. */
export const AUTO_RETRY_MAX_ATTEMPTS = 3;

const WHATSAPP = new Set(['whatsapp_meta', 'whatsapp_js']);

function minAgeMs(status: string | null | undefined): number | null {
  if (status === 'failed') return 0;
  if (status === 'pending') return PENDING_RETRY_MIN_AGE_MS;
  if (status === 'sent') return SENT_RETRY_MIN_AGE_MS;
  return null;
}

export function isWhatsappChannel(channel: string | null | undefined): boolean {
  return Boolean(channel && WHATSAPP.has(channel));
}

export function isRetryableOutboundStatus(status: string | null | undefined): boolean {
  return status === 'pending' || status === 'sent' || status === 'failed';
}

export function outboundRetryReady(
  status: string | null | undefined,
  timestampIso: string,
  now = Date.now(),
  lastAttemptAt?: number | null
): boolean {
  const minAge = minAgeMs(status);
  if (minAge == null) return false;
  if (lastAttemptAt != null) {
    const gap = status === 'failed' ? PENDING_RETRY_MIN_AGE_MS : SENT_RETRY_MIN_AGE_MS;
    return now - lastAttemptAt >= gap;
  }
  const ts = new Date(timestampIso).getTime();
  if (!Number.isFinite(ts)) return false;
  return now - ts >= minAge;
}

export function shouldAutoRetryOutbound(params: {
  channel: string | null | undefined;
  sender: string;
  isWhisper?: boolean;
  deliveryStatus?: string | null;
  timestamp: string;
  now?: number;
  lastAttemptAt?: number | null;
  autoAttemptCount?: number;
}): boolean {
  if (!isWhatsappChannel(params.channel)) return false;
  if (params.sender === 'visitor' || params.isWhisper) return false;
  if ((params.autoAttemptCount ?? 0) >= AUTO_RETRY_MAX_ATTEMPTS) return false;
  const now = params.now ?? Date.now();
  const ts = new Date(params.timestamp).getTime();
  if (!Number.isFinite(ts) || now - ts > AUTO_RETRY_MAX_AGE_MS) return false;
  return outboundRetryReady(params.deliveryStatus, params.timestamp, now, params.lastAttemptAt);
}
